import { QueryClient } from '@tanstack/react-query';

/** Its own module so the axios interceptor can reach the cache without importing the app. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});
